import React, { useEffect } from 'react';
import CardContent from './CardContent';
import classes from './checksCard.module.css';
import cn from 'classnames';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const ChecksCard = props => {
  const { checks, selectedCheck, setSelectedCheck, currentMode } = props;

  const NoChecks = () => {
    return (
      <div
        className={cn(
          classes.noRecordStyle,
          'h-100 d-flex justify-content-center align-items-center'
        )}
      >
         {FLABEL().CHECK_NO_CHECKS_AVAILABLE}
      </div>
    );
  };

  const getFirstSelectedRow = () => {
    return checks[0] || null;
  };

  useEffect(() => {
    if (selectedCheck === null) {
      const firstItem = getFirstSelectedRow();
      if (firstItem) {
        setSelectedCheck(firstItem?.id);
      }
    }
  }, [checks, selectedCheck === null]);

  return (
    <div className={cn(classes.tableWrapperbg, 'col-12 px-0 h-100')}>
      {checks && Array.isArray(checks) && checks.length ? (
        <div className={cn(classes.ChecksCard, 'col-12 px-0')}>
          {checks.map((table, rowIndex) => (
            <CardContent
              check={table}
              rowIndex={rowIndex}
              key={`table-${table.id}`}
              isSelected={table?.id === selectedCheck}
              setSelectedCheck={setSelectedCheck}
              currentMode={currentMode}
            />
          ))}
        </div>
      ) : (
        <NoChecks />
      )}
    </div>
  );
};

export default ChecksCard;
